import script from "./CustomerTestimonial.vue?vue&type=script&setup=true&lang=js"
export * from "./CustomerTestimonial.vue?vue&type=script&setup=true&lang=js"

import "./CustomerTestimonial.vue?vue&type=style&index=0&id=30a057b8&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-30a057b8"]])

export default __exports__